/**
 * Classe responsável pelo grid de stops
 * @author: Adalto Junior adaltojunior@sagaranatech.com
 * Date: 03/01/2013
 * Time: 15:38
 *
 */

import { getResourceTo } from 'react/utils/utils';

Greenmile.RouteDetail = Greenmile.RouteDetail || {};

Greenmile.RouteDetail.GridStops = function (routeId) {

    var idScreen = "routeMaps_" + routeId;
    var screenTab = "#" + idScreen;
    var container = screenTab + " #routeDetailGrid";
    var entity = "RouteDetails_" + routeId;

    const addMenu = (grid, targetEl) => {
      const optionsMenu = { targetEl, description: 'description' };
      const menu = new Greenmile.RouteDetail.Stop.Menu();
      menu.setOptionsMenu(optionsMenu);
      menu.setRouteId(routeId);

      const selectStop = (e, args) => {
        const dataItemModel = args.grid.getDataItem(args.row).model;
        const stop = dataItemModel.attributes.stop;
        const stopHasLatLng = stop.latitude && stop.longitude;
        const stopHasLocationAndLatLng =
          stop.location && stop.location.latitude && stop.location.longitude;
        const allowedStopTypes = [
          'STOP',
          'PAID_BREAK',
          'UNPAID_BREAK',
          'PAID_WAIT',
          'UNPAID_WAIT',
          'PAID_OVERNIGHT',
          'UNPAID_OVERNIGHT'
        ];
        const hasStopTypeAndIsStop =
          stop.stopType && allowedStopTypes.includes(stop.stopType.type);

        if (
          (stopHasLatLng || stopHasLocationAndLatLng) &&
          hasStopTypeAndIsStop
        ) {
          const stopId = stop.id;
          const routeId = dataItemModel.attributes.route.id;
          const stopSelection = new Greenmile.RouteDetail.StopSelection(
            routeId
          );
          stopSelection.selectOrDeselectStop(stopId);
        }
      };

      const showMenu = function (e, args) {
        if (
          !(
            e.target.classList.contains('iconNoPicture') ||
            e.target.classList.contains('iconWithPicture') ||
            e.target.classList.contains('iconUnSigned') ||
            e.target.classList.contains('iconWithSignature')
          )
        ) {
          this.showMenuToRowSelected(e, args);
          e.stopPropagation();
        }
      };

      grid.onClick.unsubscribe(selectStop);
      grid.onClick.subscribe(selectStop);

      grid.onClick.unsubscribe(showMenu.bind(menu));
      grid.onClick.subscribe(showMenu.bind(menu));

      grid.onScroll.unsubscribe(window.removeMenu);
      grid.onScroll.subscribe(window.removeMenu);
    };

    this.addActionsToGrid = function () {

        var error                 = null,
            customizeColumns      = null,
            element               = null,
            saveGridLayout        = null,
            selectorToGridActions = screenTab + " #tabsRouteDetail .gridActions",
            entityToActionGrid    = "RouteDetail";

        try {
            if (!document.querySelector(selectorToGridActions)) return;
            var afterSaveListCallback = (function (entity) {

                return function () {

                    var stops = Monet.Session.RouteDetail.screensList[routeId].stops.data;
                    App.Forms[entity].layout = {};

                    delete App.Forms.RouteDetail.layout;

                    var gridStops = new Greenmile.RouteDetail.GridStops(routeId);
                    gridStops.createGrid(stops);

                    var columnProvider = new Greenmile.RouteDetail.ColumnsToGrid();
                    var columns = null;

                    for (var key in App.Forms) {

                        if (key.match('RouteDetails_') && !key.match('_ResequenceHistory')) {

                            App.Forms[key].layout = {};

                            columnProvider.setEntity(key);
                            columns = columnProvider.getColumns();

                        }
                    }
                };

            }(entity));

            customizeColumns = new Monet.Grid.ActionsModules.CustomizeColumns();
            saveGridLayout = new Monet.Grid.ActionsModules.SaveGridLayout();

            element = document.querySelector(selectorToGridActions);

            if (element) {
                element.innerHTML = '';
            }

            customizeColumns.setEntity(entityToActionGrid);
            customizeColumns.setScreenName(entity);
            customizeColumns.setSelector(selectorToGridActions);
            customizeColumns.setElement(element);
            customizeColumns.setCustomNamespace('RouteDetails_' + routeId);

            customizeColumns.setCallBacks({
                afterSaveList: afterSaveListCallback
            });

            saveGridLayout.setEntity(entityToActionGrid);
            saveGridLayout.setScreenName(entity);
            saveGridLayout.setSelector(selectorToGridActions);
            saveGridLayout.setElement(element);

            saveGridLayout.setCallBacks({
                afterSaveList: afterSaveListCallback
            });

            customizeColumns.init();
            saveGridLayout.init();

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                'Error on show grid of stops on route monitoring.', e);
            error.console();

        }
    };
    
    this.addFilterBuilder = function () {
        let filterBuilterDiv = document.querySelector(`${screenTab} .stopList.gridActions.ui-widget-header`),	
            filterBuilder    = App.Forms[entity].filterBuilder,
            _executeFilter;

        _executeFilter = function (criteriaChain) {
            const router = App.Objects[`RouteDetails_${routeId}`];
            router.addRouteToCriteriaChain(criteriaChain, routeId);

            router.updateGrid(
                criteriaChain,
                Monet.Grid.addDataToGrid,
                true
            );
        };

        if (!filterBuilterDiv) {
            filterBuilder = new Monet.UI.FilterBuilder();
            filterBuilder.setIdScreen(idScreen);
            filterBuilder.setSelector(`${screenTab} #routeDetailGrid`);
            filterBuilder.setEntity('RouteDetail');
            filterBuilder.setCustomNameSpace(entity);

            filterBuilder.getFieldList(() => {
              filterBuilder.customRequest = _executeFilter;
              const selectorToGridActions = `${screenTab} #tabsRouteDetail .gridActions`;
              const gridActions = document.querySelector(selectorToGridActions);

              if (gridActions) {
                const div = document.createElement('div');
                div.className = 'stopList gridActions ui-widget-header';
                div.appendChild(filterBuilder.el);

                gridActions.parentNode.appendChild(div);

                filterBuilder.render();
                App.Forms[entity].filterBuilder = filterBuilder;
                gridActions.style.display = 'flex';
              }
            });
        }

        delete filterBuilder.fieldList['routeView.secondaryAssignments.driver.key'];
        delete filterBuilder.fieldList['routeView.secondaryAssignments.driver'];
        delete filterBuilder.fieldList['route.driverAssignments.driver'];
        delete filterBuilder.fieldList['route.driverAssignments.driver.key'];

        filterBuilder.setFieldsToDisplayOnFilterBuilder(Object.keys(filterBuilder.fieldList));
        filterBuilder.render();
        filterBuilder.adjustHeaderSize();

    };

    const threatLineStyles = (dataView) => {
      const oldMetadata = dataView.getItemMetadata;

      dataView.getItemMetadata = function (rowIndex) {
        const item = this.getItem(rowIndex);
        const meta =
          (typeof oldMetadata === 'function'
            ? oldMetadata.call(this, rowIndex)
            : {}) || {};

        if (
          item &&
          item.model &&
          item.model.attributes &&
          Object.keys(item.model.attributes).length > 0
        ) {
          meta.cssClasses = meta.cssClasses || '';

          const stop = item.model.attributes.stop || {};
          const location = stop.location || {};

          const hasStopCoords = stop.latitude && stop.longitude;
          const hasLocationCoords = location.latitude && location.longitude;

          if (!hasStopCoords && !hasLocationCoords) {
            meta.cssClasses += ' no-stop-position';
            meta.attr = {
              titletext: Monet.I18n.getResourcesByKey(
                'RouteDetail.location.noPosition'
              )
            };
          } else {
            meta.cssClasses += ' stop-with-position';
          }
        }

        return meta;
      };
    };


    /**
     * Alteracao pra a task GM-10465 Adicionar informações de Origem e Destino na Route Detail
     * @param stops
     * @returns {*}
     */
    var threatOriginDestination = function (stops) {
        var stopModels = stops.models;
        var filterBuilder = App.Forms[entity].filterBuilder;
        var criteriaChain = filterBuilder.getCriteriaChain();

        //Adicionar origem e destino apenas quando forem exibidos todos os stops.
        if (!stopModels || !stopModels.length || criteriaChain.criteriaChain[0].and.length) {
            return stops;
        }

        var stopType = { type: 'DEPOT' };
        var route = stopModels[0].attributes.route;
        route.hasPicture = false;

        if (route.origin) {

            var origin = { route: route };
            origin.id = route.origin.id  + '_origin';

            if (!stops.getById(origin.id)) {

                origin.stop = JSON.parse(JSON.stringify(route));
                origin.stop.location = route.origin;
                origin.stop.stopType = stopType;
                origin.stop.latitude = route.origLatitude;
                origin.stop.longitude = route.origLongitude;
                origin.organization = stopModels[0].attributes.organization;


                delete origin.stop.baseLineArrival;
                delete origin.stop.plannedArrival;
                delete origin.stop.projectedArrival;
                delete origin.stop.actualArrival;
                delete origin.stop.baseLineComplete;
                delete origin.stop.plannedComplete;
                delete origin.stop.actualComplete;
                delete origin.stop.actualArrivalDataQuality;
                delete origin.stop.actualDistanceDataQuality;
                delete origin.stop.actualDistance;
                delete origin.stop.plannedDistance;
                delete origin.stop.baseLineDistance;
                delete origin.stop.projectedDistance;

                stops.add(new App.Models.StopView(origin), { at: 0 });
            }

        }

        if (route.destination) {

            var destination = {};
            destination.id = route.destination.id  + '_destination';
            if (!stops.getById(destination.id)) {
                destination.stop = JSON.parse(JSON.stringify(route));
                destination.stop.stopType = stopType;
                destination.stop.location = route.destination;
                destination.stop.latitude = route.destLatitude;
                destination.stop.longitude = route.destLongitude;
                destination.organization = stopModels[0].attributes.organization;
                delete destination.stop.baseLineDeparture;
                delete destination.stop.plannedDeparture;
                delete destination.stop.projectedDeparture;
                delete destination.stop.actualDeparture;
                delete destination.stop.baseLineStart;
                delete destination.stop.plannedStart;
                delete destination.stop.actualStart;
                delete destination.stop.actualDepartureDataQuality;

                stops.add(new App.Models.StopView(destination), { at: stops.length });
            }

        }

        return stops;

    };

    const createTrackingTooltip = () => {
      const oldTooltip = document.querySelector('.tracking-tooltip');
      const tooltip = document.createElement('div');
      tooltip.className = 'tracking-tooltip';

      if (oldTooltip) {
        document.body.removeChild(oldTooltip);
      }
      document.body.appendChild(tooltip);

      function show(content, event) {
        tooltip.textContent = content;
        tooltip.style.display = 'block';
        move(event);
      }

      function move(event) {
        tooltip.style.left = event.clientX + 16 + 'px';
        tooltip.style.top = event.clientY + 16 + 'px';
      }

      function hide() {
        tooltip.style.display = 'none';
      }

      return { show, move, hide };
    };

    this.populateGrid = function (stops, columns) {
        stops = threatOriginDestination(stops);
        Monet.Grid.addDataToGrid(entity, columns, stops, false, { scrollRowToTop: false });
    };

    this.createGrid = function (stops, { isToAddActions = true } = {}) {
        const router = new App.Routers.RouteDetails();
        const columnProvider = new Greenmile.RouteDetail.ColumnsToGrid();
        let dataView,
            grid,
            appForms,
            selectorToGridActions = `${screenTab} #tabsRouteDetail .gridActions`,
            entityToActionGrid    = "StopView";

        const options = {
            entity: entity,
            columnCheckBox: {
                show: false
            },
            selectorToGridActions: selectorToGridActions,
            entityToActionGrid: entityToActionGrid,
            gridContainner: container,
            columnEdit: {
                show: false
            },
            headerMenu: {
                headerMenuEventClass: Monet.Grid.ActionsModules.MenuShowTotals
            },
            multiColumnSort: true,
            rowHeight: 30,
            multiSelect: false
        };

        router.createGreenmileSessionsToRouteDetail(routeId);
        columnProvider.setEntity(entity);
        columnProvider.getColumns(function (columns) {
          if (!document.querySelector(screenTab)) return;
          
          dataView = new Monet.Grid.DataProvider(columns, null, entity);

          const columnFrozen = Monet.Grid.getIndexFrozenColumn(App.Forms[entity].layout.index);
          options.frozenColumn = columnFrozen + 1;
  
          grid = new Monet.Grid.GenericGrid(container, dataView, columns, options);  
          
          appForms = App.Forms[entity];
          appForms.routeId = routeId;
          appForms.table = grid;
          appForms.dataProvider = dataView;
          appForms.gridStops = this;
          threatLineStyles(dataView);

          const tooltip = createTrackingTooltip();

          grid.onMouseEnter.subscribe((event) => {
            const { target: { parentElement } } = event;

            if (parentElement.classList.contains('no-stop-position')) {
              const content = getResourceTo('routedetails.tooltip.nolocation');
              tooltip.show(content, event);

              parentElement.addEventListener('mousemove', tooltip.move);
            }
          });

          grid.onMouseLeave.subscribe(({ target: { parentElement } }) => {
            tooltip.hide();
            if (parentElement) {
              parentElement.removeEventListener('mousemove', tooltip.move);
            }
          });

          if (isToAddActions) {
            this.addActionsToGrid(columns);
          }
  
          this.addFilterBuilder();
  
          this.populateGrid(stops, columns);
  
          Monet.Session.RouteDetail.screensList[routeId].stops.data = stops;
          addMenu(grid, container);
          if (typeof hideTooltip === 'function') {
            hideTooltip();
          }
        }.bind(this));

    };
};
